// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customBorderlessSelector_borderlessSelect__YMn\\+t {
  border: none;
  color: #007c7c;
  font-weight: bold;

  border-radius: 0;
  -webkit-border-radius: 0;
  cursor: pointer;
  background: transparent;
}

.customBorderlessSelector_borderlessSelect__YMn\\+t:focus-visible {
  border: 1px solid transparent;
  outline: none;
}

.customBorderlessSelector_borderlessSelect__YMn\\+t:disabled {
  color: #c4c4c4;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/Select/customBorderlessSelector.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;;EAEjB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".borderlessSelect {\n  border: none;\n  color: #007c7c;\n  font-weight: bold;\n\n  border-radius: 0;\n  -webkit-border-radius: 0;\n  cursor: pointer;\n  background: transparent;\n}\n\n.borderlessSelect:focus-visible {\n  border: 1px solid transparent;\n  outline: none;\n}\n\n.borderlessSelect:disabled {\n  color: #c4c4c4;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"borderlessSelect": `customBorderlessSelector_borderlessSelect__YMn+t`
};
export default ___CSS_LOADER_EXPORT___;
